<template>
  <div class="con" v-loading="loading">
    <div>
      <div class="text item">
        <div class="firewall">   
          <div class="defualt">
            <!-- 基本配置模块 -->
            <default-table :defaultList="firewallData.default"></default-table>
          </div>
          <div class="redirect" style="margin-top: 25px">
            <!-- 通信规则模块 -->
            <redirect-table 
              :redirectList="firewallData.redirect" 
              :IpList="IpList" 
              :redirectLength="redirectLength" 
              :deleteOptions="deleteOptions"
              :deviceDid="deviceDid"
              :deviceSn="deviceSn"
              @updateData='updateFirewall'>
            </redirect-table>
          </div>
        </div>
      </div>
      <el-button
        type="danger"
        size="mini"
        @click="updateRedirect"
        class="Config-Buttom">
        {{$t('lang.ConfigSetting.SaveApply')}}
      </el-button>
    </div>
  </div>
</template>
<script>
import { updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import tableComponent from '@/components/TableComponent/index'
import defaultTable from './components/defaultTable'
import redirectTable from './components/redirectTable'
import { cloneDeep, isEqual} from 'lodash'
export default {
  props: ["deviceDid", "deviceSn"],
  components: {
    tableComponent,
    defaultTable,
    redirectTable,
  },
  data() {
    return {
      checked: true,
      //控制dom更新的生命周期操作
      UpData: true,
      IpList: [],
      updateData: [],
      deleteOptions: [],
      // 网络接口基本信息
      networkInfo: {},
      firewallData: {default:[], redirect: []},
      loading: false,
      redirectLength: 0,
      copyData: {default:[], redirect: []},
      loading: false
    };
  },
  mounted(){
     //获取下拉ip列表
    listConfig(this.deviceSn,this.deviceDid,[{section:'arp',config:'arp'}]).then((res)=>{
      this.IpList=res.data.data.mess[0].s_objects.map((val)=>{
        return {value:val.ipaddr,label:`${val.ipaddr} (${val.macaddr})`}
      })
      this.IpList.push({value:'自定义',label:this.$t('lang.ConfigSetting.custom')})
      this.IpList.push({value:'',label:this.$t('lang.firewall.all')})         
    })
    this.getConfig()
    // this.fetchNetworkInfo()
  },
  methods: {
    // 获取防火墙数据
    getConfig() {
      this.firewallData = {default:[], redirect: []}
      this.loading = true
      listConfig(this.deviceSn, this.deviceDid, [
        {
          section: "defaults",
          config: "firewall",
          options: [
            { option: "syn_flood" },
            { option: "drop_invalid" },
            { option: "input" },
            { option: "output" },
            { option: "forward" },
            { option: "" }
          ]
        },
        {
          section: "redirect",
          config: "firewall",
          options: [
            { option: "enabled" },
            { option: "target" },
            { option: "src" },
            { option: "src_ip" },
            { option: "dest" },
            { option: "proto" },
            { option: "src_dip" },
            { option: "name" },
            { option: "dest_ip" },
            { option: "extra" }
          ]
        }
      ]).then(res => {              
        res.data.data.mess.forEach((item, index) => {
          if(item.section === 'redirect') {
            this.redirectLength = item.s_objects.length
            item.s_objects.forEach((ele, index) => {
              let eleObj = ele
              this.$set(eleObj, 'index', index)
              if(ele.options.target == 'SNAT') {
                eleObj.options.enabled = eleObj.options.enabled == '0' ? false : true
                this.firewallData.redirect.push(eleObj)
              }
            })
          }else if(item.section === 'defaults') {
            item.s_objects.forEach((ele, index) => {
              let eleObj = ele
              this.$set(eleObj, 'index', index)
              eleObj.options.drop_invalid = eleObj.options.drop_invalid == '1' ? true : false
              eleObj.options.syn_flood = eleObj.options.syn_flood  == '1' ? true : false
              this.firewallData.default.push(eleObj)
            })
          }
        })
        this.copyData = cloneDeep(this.firewallData)
        this.loading = false
      }).catch(err => {
        this.$message({
          message: this.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    // 更新数据
    updateFirewall(){
      this.getConfig()
    },
     // 更新并应用
    updateRedirect() {
      if(!isEqual(this.copyData, this.firewallData)) {
        let data = []
        this.firewallData.default.forEach((item, index) => {
          let action = 0
          let options = cloneDeep(item.options)
          options.drop_invalid = options.drop_invalid ? "1" : ""
          options.syn_flood = options.syn_flood ? "1" : ""
          if(item.action == undefined) {
            action = 0
          }else{
            action = item.action
          }
          data.push({
            server: "firewall",
            config: 'firewall',
            section:'defaults',
            action: action,
            options: options,
            index: [item.index]
          })
        })
        this.firewallData.redirect.forEach((item, index) => {
          let action = 0
          let options = cloneDeep(item.options)
          options.enabled = options.enabled == false ? "0" : ""
          if(item.action == undefined) {
            action = 0
          }else{
            action = item.action
          }
          data.push({
            server: "firewall",
            config: 'firewall',
            section: 'redirect',
            action: action,
            options: options,
            index: [item.index]
          })
        })
        this.deleteOptions.forEach((item, index) => {
          let options = cloneDeep(item.options) 
          if(options.enabled) {
            options.enabled = '1'
          }else{
            options.enabled = '0'
          }
          
          data.push({
            section: "redirect",
            config: "firewall",
            action: item.action,
            index: [item.index],
            server: "firewall",
            options: options
          })
        })
        updateConfig(this.deviceSn,this.deviceDid,data).then((res)=>{
          if(res.data.data.mess===0){
            this.$message({
              showClose: true,
              message: this.$t('lang.ConfigSetting.Successfulconfiguration'),
              type: 'success'
            });
            this.deleteOptions = []
            this.getConfig()
          }
          else {
            this.$message({
            showClose: true,
            message: this.$t('lang.ConfigSetting.Configurationerror'),
              type: 'warning'
            });
            this.getConfig()
            return
          }
        })
      }else{
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return
      }
      
    },
  },
};
</script>
<style scoped>
.con {
  width: 100%;
  margin: 0 auto;
}
.Form-Input-Width {
  width: 5rem;
}
.Form-Buttom {
  margin-left: 0.2rem;
}
.checked {
  margin-left: 1rem;
}
.text {
  font-size: 14px;
}
.item {
  padding: 18px 0;
}
.Config-Buttom {
  display: table;
  margin: 30px auto;
  font-size: 14px;
  overflow: hidden;
}
.firewall{
  margin-top: 20px;
}
</style>
<style src='../common.css' scoped></style>

